var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var KeyHandler = /** @class */ (function (_super) {
    __extends(KeyHandler, _super);
    function KeyHandler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyPress = function (event) {
            event.preventDefault();
            if (event.keyCode === _this.props.keyCode) {
                _this.props.handler(event);
            }
        };
        return _this;
    }
    KeyHandler.prototype.componentDidMount = function () {
        window.document.addEventListener(this.props.keyEventType, this.handleKeyPress, false);
    };
    KeyHandler.prototype.componentWillUnmount = function () {
        window.document.removeEventListener(this.props.keyEventType, this.handleKeyPress);
    };
    KeyHandler.prototype.render = function () {
        return React.createElement(React.Fragment, null);
    };
    return KeyHandler;
}(React.Component));
export { KeyHandler };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/key-handler/KeyHandler.tsx
// module id = 972
// module chunks = 3